<template>
  <span
    :class="{
      'small': !minimal,
      'tiny': minimal,
      'danger': isExceeded
    }">
    {{ timeFormatted }}

    <f-icon
      v-if="!minimal && isExceeded"
      name="check_circle" />
  </span>
</template>
<script>

export default {
  name: 'f-time-elapsed',
  props: {
    minimal: {
      type: Boolean,
      default: false
    },
    time: {
      type: String,
      default: '',
      required: false
    },
    // Time in seconds, 'time' was longer  than 'maxTime' from current date 'time' will be marked as exceeded
    maxTime: {
      type: Number,
      default: 604800,
      required: false
    }
  },
  data() {
    return {
      timeFormatted: this.$t('ui.none').toLowerCase(),
      isExceeded: false
    }
  },
  mounted () {
    if (this.time) {
      let dateObject = new Date(this.time);
      let seconds = Math.floor((new Date() - dateObject) / 1000);
      this.isExceeded = this.maxTime > 0 ? seconds > this.maxTime : false;
      this.timeFormatted = this.getTimeElapsedText(seconds);
    }
  },
  methods: {
    getTimeElapsedText (seconds) {
      let timeElapsed = '';
      let isAgo = !this.minimal && ((seconds / 60) > 1);

      if ((seconds / 31536000) > 1) {
        let translationKey = isAgo ? 'time.timeElapsedYearAgo' : 'time.timeElapsedYear';
        return this.$tc(translationKey, Math.floor(seconds / 31536000));
      } else if ((seconds / 2592000) > 1) {
        let translationKey = isAgo ? 'time.timeElapsedMonthAgo' : 'time.timeElapsedMonth';
        return this.$tc(translationKey, Math.floor(seconds / 2592000));
      } else if ((seconds / 86400) > 1) {
        let translationKey = isAgo ? 'time.timeElapsedDayAgo' : 'time.timeElapsedDay';
        return this.$tc(translationKey, Math.floor(seconds / 86400));
      } else if ((seconds / 3600) > 1) {
        let translationKey = isAgo ? 'time.hoursShortAgo' : 'time.hoursShort';
        return this.$tc(translationKey, Math.floor(seconds / 3600));
      } else if ((seconds / 60) > 1) {
        let translationKey = isAgo ? 'time.minutesShortAgo' : 'time.minutesShort';
        return this.$tc(translationKey, Math.floor(seconds / 60));
      } else if ((seconds / 60) < 1) {
        return this.$t('time.now');
      }

      console.warn('time span not handeled, should not occure', seconds);
      return timeElapsed;
    }
  }
}
</script>
